import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { authApi } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const refresh = useCallback(() => authApi.me().then((r) => setUser(r.user)).catch(() => setUser(false)), []);
  useEffect(() => { refresh(); }, [refresh]);
  const logout = async () => { await authApi.logout().catch(() => {}); setUser(false); };
  return <AuthCtx.Provider value={{ user, setUser, logout, refresh }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);

const Spinner = () => <div className="min-h-screen grid place-items-center"><Loader2 className="h-6 w-6 animate-spin text-[#0072C6]" /></div>;

export const homeFor = (u) => (u?.role === "admin" ? "/admin" : u?.role === "client" ? "/portal" : "/login");

export const RequireRole = ({ role, children }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <Spinner />;
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  if (user.role !== role) return <Navigate to={homeFor(user)} replace />;
  return children;
};

export const RoleHome = () => {
  const { user } = useAuth();
  if (user === null) return <Spinner />;
  return <Navigate to={homeFor(user)} replace />;
};
